import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { get } from "lodash"
import axios from "axios"
import Select from "react-select"
import TextInput from "../../Comp/TextInput"
import { JSON } from "window-or-global";

export const REPRESENTING_TYPE_OPTIONS = [
  { label: "Buyer", value: "buyer" },
  { label: "Seller", value: "seller" },
  { label: "Landlord", value: "landlord" },
  { label: "Tenant", value: "tenant" },
  { label: "Referral", value: "referral" },
]

// Which client_type should be primary for a given deal-level client_type;
// tenant deals fall back to buyer clients, landlord deals to seller clients
export const PRIMARY_CLIENT_TYPE_PREFERENCE = {
  buyer: ["buyer", "tenant"],
  seller: ["seller", "landlord"],
  tenant: ["tenant", "buyer"],
  landlord: ["landlord", "seller"],
  referral: ["referral"],
}

// Orders clients so the one matching the deal-level client_type
// (or its equivalent side, e.g. tenant -> buyer) lands at index 0
export const orderClientsByDealType = (clients = [], dealClientType) => {
  const preference = PRIMARY_CLIENT_TYPE_PREFERENCE[dealClientType]
  if (!preference || !clients || clients.length < 2) return clients || []
  const rank = (client) => {
    const index = preference.indexOf(client.client_type)
    return index === -1 ? preference.length : index
  }
  return [...clients].sort((a, b) => rank(a) - rank(b))
}

export const getPrimaryClient = (clients = [], dealClientType) => orderClientsByDealType(clients, dealClientType)[0] || null

// A client only counts as "Client" when its type matches the side we represent on this deal
// (or the deal is dual, i.e. we represent both sides). Otherwise it's the other party on the
// transaction, so it's labeled by its own type instead, e.g. "Buyer Information".
export const getClientCardLabel = (client = {}, dealClientType, isDual) => {
  if (isDual || !dealClientType || !client.client_type) {
    return "Client"
  }
  const matchingTypes = PRIMARY_CLIENT_TYPE_PREFERENCE[dealClientType] || [dealClientType]
  if (matchingTypes.includes(client.client_type)) {
    return "Client"
  }
  const option = REPRESENTING_TYPE_OPTIONS.find(item => item.value === client.client_type)
  return `${option ? option.label : client.client_type} Information`
}

// Falls back to the legacy combined `name` field for clients saved before it was split in two
export const getClientDisplayName = (client = {}) => `${client.firstname || ""} ${client.lastname || ""}`.trim() || client.name || ""

// The API has shipped this option as both "other" and "others", so match either
export const isOtherSource = source => ["other", "others"].includes(String(source || "").toLowerCase())

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    borderRadius: 10,
    backgroundColor: "#FFFFFF",
    borderColor: state.isFocused ? "#155DFC" : "#E2E8F0",
    boxShadow: "none",
    "&:hover": {
      borderColor: state.isFocused ? "#155DFC" : "#E2E8F0",
    },
  }),
  placeholder: base => ({
    ...base,
    color: "rgba(29, 41, 61, 0.5)",
  }),
  menu: base => ({
    ...base,
    zIndex: 5,
  }),
}

const Wrap = styled.div`
  display: flex;
  opacity: 0.4;
  pointer-events: none;
  flex-wrap: wrap;

  ${props => props.isEnable && `
    opacity: 1;
    pointer-events: inherit;
  `}
`

const Label = styled.div`
  color: #A3A3A3;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 14px;
  width: 100%;
  margin-bottom: 10px;
  height: 16px;
`

const ClientItem = styled.div`
  border: 1px solid #D3DAE8;
  border-radius: 20px;
  width: 350px;
  padding: 20px;
  margin-right: 20px;
  min-height: 200px;
  padding-bottom: 20px;
  position: relative;
  margin-top: 20px;
  input {
    margin-top: 12px;
  }

  ${props => props.isAdd && `
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px #D3DAE8 dashed;
    cursor: pointer;
  `}

  ${props => props.disable && `
     display: none;
   `}
`

const RemoveBTN = styled.p`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 16px;
  color: red;
  font-size: 14px;
  font-weight: bold;
  margin: 0px;
`

const FieldLabel = styled.div`
  color: #45556C;
  font-size: 14px;
  margin-bottom: 8px;
  margin-top: 12px;
`

const AddNewClient = ({
 addClient,
 disable,
}) => (
  <ClientItem disable={disable} isAdd onClick={addClient}>
    <span>+ Click to add more client</span>
  </ClientItem>
)

const ClientReselector = ({
  handleInput,
  errorFields,
  addClient,
  removeClient,
  agentId,
  searchClientByText,
  clients,
  secureIdForTC,
  isEdit,
  dealClientType,
  isDual,
}) => {
  const [fetchedClient, setFetchedClients] = useState([])
  const [errorIndex, setErrorIndex] = useState()
  const [clientSourceOptions, setClientSourceOptions] = useState([])
  const isEnable = agentId && secureIdForTC

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL
    axios.get(`${baseUrl}/v1.0/fetch-filter-values`, {
      headers: {
        "secure-id": secureIdForTC,
      },
    }).then(({ data }) => {
      const sources = get(data, "response.client_source", [])
      setClientSourceOptions(sources.map(source => ({
        label: source.display_name,
        value: source.value,
      })))
    }).catch(() => {
      setClientSourceOptions([])
    })
  }, [])

  const handleSearchText = (text) => {
    // searchClientByText({
    //   text: value,
    //   secureId: secureIdForTC,
    //   agentId,
    // })
    console.log({ text });
    //loadOptions(text)
  }

  const loadOptions = (text, callback) => {
    try {
      const baseUrlV2 = `${process.env.REACT_APP_API_BASE_URL}/v2.0`;
      const payload = {
        text,
        sort_by: "created_at",
        ascending: false,
        aggregationNotRequired: false,
        start: 0,
        agentId: Number(agentId),
        end: 10,
      }
      const json = fetch(`${baseUrlV2}/clients/search`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "internal-id": "e82f206e5238e9cfbfb613e7a298be34",
          "content-type": "application/json",
        },
      }).then(res => res.json())
      const { clients } = json.response
      if (clients && clients.length > 0) {
        const clientList = clients.map(x => ({
          label: x.name,
          value: {
            name: x.name,
            phone: get(x, "phones[0].phone"),
            email: get(x, "emails[0].email"),
            client_id: x.id,
          }
        }))
        setFetchedClients(clientList)
        callback()
      }
    } catch (error) {

    }
  }

  const handleUpdate = (text, field, index) => {
    const newClient = [...clients]
    newClient[index][field] = text
    handleInput(newClient)
  }

  // Picking a non-other source drops any previously typed free-text value so it isn't submitted
  const handleSourceUpdate = (value, index) => {
    const newClient = [...clients]
    newClient[index].source = value
    if (!isOtherSource(value)) {
      newClient[index].other_source = ""
    }
    handleInput(newClient)
  }

  return (
    <Wrap isEnable={isEnable || true}>
      {clients && clients.map((item, index) => (
        <ClientItem key={index}>
          <Label>
            {isEdit ? getClientCardLabel(item, dealClientType, isDual) : "Client"}
          </Label>
          {index > 0 && (
            <RemoveBTN onClick={() => { removeClient(index) }}>Remove</RemoveBTN>
          )}
          {/* <AsyncSelect
            cacheOptions={fetchedClient}
            loadOptions={loadOptions}
            defaultOptions
            options={fetchedClient}
            onInputChange={handleSearchText}
          /> */}
          <TextInput
            name="firstname"
            placeholder="First Name"
            value={item.firstname}
            onChange={(e) => { handleUpdate(e.target.value, e.target.name, index) }}
            isHideLabel
          />
          <TextInput
            name="lastname"
            placeholder="Last Name"
            value={item.lastname}
            onChange={(e) => { handleUpdate(e.target.value, e.target.name, index) }}
            isHideLabel
          />
          <TextInput
            name="email"
            type="email"
            onChange={(e) => { handleUpdate(e.target.value, e.target.name, index) }}
            placeholder="Client Email"
            value={item.email}
            isHideLabel
          />
          <TextInput
            name="phone"
            placeholder="Client Phone"
            value={item.phone}
            onChange={(e) => { handleUpdate(e.target.value, e.target.name, index) }}
            isHideLabel
          />
          <FieldLabel>Client Type</FieldLabel>
          <Select
            placeholder="Buyer"
            options={REPRESENTING_TYPE_OPTIONS}
            value={REPRESENTING_TYPE_OPTIONS.find(option => option.value === item.client_type) || null}
            onChange={(selectedItem) => { handleUpdate(selectedItem.value, "client_type", index) }}
            styles={selectStyles}
            isDisabled={isEdit && !!item.id}
          />
          <FieldLabel>Source *</FieldLabel>
          <Select
            placeholder="Select Source"
            options={clientSourceOptions}
            value={clientSourceOptions.find(option => option.value === item.source) || null}
            onChange={(selectedItem) => { handleSourceUpdate(selectedItem.value, index) }}
            styles={selectStyles}
          />
          {isOtherSource(item.source) && (
            <>
              <FieldLabel>Other Client Source *</FieldLabel>
              <TextInput
                name="other_source"
                placeholder="Other Client Source"
                value={item.other_source}
                onChange={(e) => { handleUpdate(e.target.value, e.target.name, index) }}
                isHideLabel
              />
            </>
          )}
        </ClientItem>
      ))}

      <AddNewClient addClient={() => { addClient({}) }} disable={clients && clients.length === 4} />
    </Wrap>
  )
}

export default ClientReselector
